import styled from "@emotion/styled"

const StyledHeader = styled.h1`
  background: no-repeat center/100% url(${(props) => props.banner});
  padding: 0rem 2rem;
  width: fit-content;
`

export default StyledHeader
